import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import { IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

import { usePersistReduxStore } from './common/hooks/usePersistReduxStore';
import { CLIENT_PAGES, CLIENT_ROUTES } from './utils/client/client-routes';
import { withAuthentication } from './wrappers/withAuthentication';

import 'antd/dist/antd.css';

import BVApplicationLayout from './common/layouts/BVApplicationLayout/bv-application-layout';

import AdminPage from './pages/AdminPage/admin-page';
import CustomersPage from './pages/CustomersPage/customers-page';
import LoginPage from './pages/LoginPage/login-page';
import ProductsDetailPage from './pages/Products/ProductsDetailPage/products-detail-page';
import ProductsPage from './pages/Products/ProductsPage/products-page';
import ProductsTypePage from './pages/Products/ProductsTypePage/products-type-page';

type IApp = {
	msalInstance: IPublicClientApplication;
};

const App: React.FunctionComponent<IApp> = ({ msalInstance }) => {
	const { handlePersistingStore } = usePersistReduxStore();

	const _handleRouteComponent: any = (route: any) => {
		switch (route.name) {
			case CLIENT_PAGES.LOGIN: {
				return LoginPage;
			}
			case CLIENT_PAGES.HOMEPAGE:
			case CLIENT_PAGES.CUSTOMERS: {
				return route.needAuthentication
					? withAuthentication(CustomersPage)
					: CustomersPage;
			}
			case CLIENT_PAGES.PRODUCTS_TYPE: {
				return route.needAuthentication
					? withAuthentication(ProductsTypePage)
					: ProductsTypePage;
			}
			case CLIENT_PAGES.PRODUCTS: {
				return route.needAuthentication
					? withAuthentication(ProductsPage)
					: ProductsPage;
			}
			case CLIENT_PAGES.PRODUCTS_DETAILS: {
				return route.needAuthentication
					? withAuthentication(ProductsDetailPage)
					: ProductsDetailPage;
			}
			case CLIENT_PAGES.ADMIN: {
				return route.needAuthentication
					? withAuthentication(AdminPage, true)
					: AdminPage;
			}
			default: {
				return null;
			}
		}
	};

	useEffect(() => {
		handlePersistingStore();
	});

	return (
		<MsalProvider instance={msalInstance}>
			<BVApplicationLayout>
				<Switch>
					{CLIENT_ROUTES.map((routeData, routeIndex) => {
						const routeComponent = _handleRouteComponent(routeData);

						return (
							<Route
								key={routeIndex}
								exact
								path={routeData.path}
								component={routeComponent}
							/>
						);
					})}
				</Switch>
			</BVApplicationLayout>
		</MsalProvider>
	);
};

export default App;
